import React, { useEffect, useState } from "react";
import axios from "axios";
import { Quote } from "lucide-react";
import { SectionHead } from "@/components/SectionHead";
import { Stars } from "@/components/StarRating";
import { Stagger, StaggerItem } from "@/lib/motion";
import { imgSrc } from "@/lib/img";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Testimonials = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/testimonials`).then(({ data }) => setItems(data)).catch(() => {});
  }, []);
  if (items.length === 0) return null;

  return (
    <section data-testid="testimonials-section" className="py-20 sm:py-28 bg-creamdark/40 border-y border-forest/10">
      <div className="container-nb">
        <SectionHead eyebrow="Loved by Families" title="Trusted in kitchens across India." />
        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t) => (
            <StaggerItem key={t.id}>
              <div data-testid={`testimonial-${t.id}`} className="h-full bg-white rounded-2xl border border-forest/10 p-7 flex flex-col hover:shadow-lg hover:shadow-forest/5 transition-all duration-500">
                <Quote size={26} className="text-gold/60" strokeWidth={1.5} />
                <p className="font-serif text-lg text-forest leading-snug mt-4 flex-1">"{t.quote}"</p>
                <div className="flex items-center gap-3 mt-6 pt-5 border-t border-forest/10">
                  {t.photo ? (
                    <img src={imgSrc(t.photo)} alt={t.name} className="w-11 h-11 rounded-full object-cover" />
                  ) : (
                    <span className="w-11 h-11 rounded-full bg-forest/10 text-forest font-serif flex items-center justify-center">{t.name.charAt(0)}</span>
                  )}
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-forest">{t.name}</p>
                    {t.location && <p className="text-[11px] text-mutedgreen">{t.location}</p>}
                  </div>
                  <Stars value={t.rating} size={13} />
                </div>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
